import type { PlatformClient } from "../PlatformClient";
import type { InfoConfig, UpdateInfoConfigBody } from "./departments";

export type { InfoConfig, UpdateInfoConfigBody };

export function createClientApi(client: PlatformClient) {
    return {
        getInfoConfig(id: string) {
            return client.get<InfoConfig>(`api/clients/${id}/info-config`);
        },

        updateInfoConfig(id: string, body: UpdateInfoConfigBody) {
            return client.patch<InfoConfig>(`api/clients/${id}/info-config`, body);
        },

        uploadInfoConfigFile(id: string, file: File, label?: string) {
            const form = new FormData();
            form.append("file", file);
            if (label) form.append("label", label);
            return client.upload<InfoConfig>(`api/clients/${id}/info-config/files`, form);
        },

        deleteInfoConfigFile(id: string, fileID: string) {
            return client.delete<void>(`api/clients/${id}/info-config/files/${fileID}`);
        },
    };
}

export type ClientApi = ReturnType<typeof createClientApi>;
